declare var require: any
const version = require('../../package.json').version

export const environment = {
  production: true,
  url: "https://backend.neo.feature.8devs.com",
  backendVersion: "v1",
  version: version + "--feature"
}
